/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PaymentManagementRequestStateType =
  typeof PaymentManagementRequestStateType[keyof typeof PaymentManagementRequestStateType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentManagementRequestStateType = {
  REQUESTED: 'REQUESTED',
  FAILED: 'FAILED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
} as const;
